var React = require('react');

function HamburgerMenuHeaderClose (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0}),React.createElement("path",{"d":"M10.6,9.3L17.7,2c0.4-0.5,0.4-1.2,0-1.6c-0.5-0.4-1.2-0.4-1.6,0L9,7.7L2,0.4C1.6,0,0.9,0,0.4,0.4\r\n\tC0,0.8,0,1.5,0.4,2l7.1,7.4l-7.1,7.4c-0.4,0.5-0.4,1.2,0,1.6c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3L9,11l7,7.3\r\n\tc0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.5-0.4,0.5-1.2,0-1.6L10.6,9.3z","key":1})]);
}

HamburgerMenuHeaderClose.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"12.5px","height":"13px","viewBox":"0 0 18.2 18.7"};

module.exports = HamburgerMenuHeaderClose;

HamburgerMenuHeaderClose.default = HamburgerMenuHeaderClose;
